import { ApiRef, createApiRef } from '@backstage/frontend-plugin-api';
import {
  MainAskResponse,
  MainFeedbackRequest,
  MainFeedbackResponse,
} from './alma-sdk';

export type AlmaConversationMessage = {
  role: string;
  content: string;
};

export type MainLastConversationResponse = {
  conversationId: number;
  messages: AlmaConversationMessage[];
};

export type MainConversationSummary = {
  conversationId: number;
  title: string;
  updatedAt: string;
};

export type MainRecentConversationsResponse = {
  conversations: MainConversationSummary[];
};

/**
 *
 * @public
 */
export interface AlmaApi {
  ask(
    message: string,
    conversationId?: number,
    pageContext?: string,
  ): Promise<AlmaApiResponse<MainAskResponse>>;
  feedback(
    data: MainFeedbackRequest,
  ): Promise<AlmaApiResponse<MainFeedbackResponse>>;
  getLastConversation(): Promise<AlmaApiResponse<MainLastConversationResponse>>;
  getRecentConversations(
    limit?: number,
  ): Promise<AlmaApiResponse<MainRecentConversationsResponse>>;
  getConversationById(
    conversationId: number,
  ): Promise<AlmaApiResponse<MainLastConversationResponse>>;
  deleteConversation(
    conversationId: number,
  ): Promise<AlmaApiResponse<{ status: string }>>;
}

export const almaApiRef: ApiRef<AlmaApi> = createApiRef<AlmaApi>({
  id: 'plugin.neo4j-alma.service',
});

export type AlmaApiResponse<T> = {
  ok: boolean;
  value?: T | undefined;
  statusCode: number;
  message: string;
};
